import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { BreadcrumbService } from '../services/common/breadcrumb.service';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbGuard {
  constructor(private breadcrumbService: BreadcrumbService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (next.data && next.data.name) {
      let url: string = next.url && next.url.length > 0 ? '' : '/';
      for (let urlSegment of next.url) if (urlSegment.path) url += `/${urlSegment.path}`;
      return this.breadcrumbService
        .create([url, next.data.name])
        .then((response_json) => {
          return true;
        })
        .catch((err) => {
          console.error('Breadcrumb error', err);
          return true;
        });
    } else return true;
  }
}
